<app-spinner-container [isLoading]="exportReportsBtnsComponent?.isLoading " [diametre]="65">
    <app-card [isHeader]=true [title]="'etat'|translate">
        <mat-card-content class="px-2">

            <mat-form-field appearance="outline">
                <mat-label> {{"acheteur-fournisseur"|translate}}</mat-label>
                <mat-select disableOptionCentering [(ngModel)]="key">
                    <mat-option [value]="'acheteur'">
                        {{"acheteur"|translate}}
                    </mat-option>
                    <mat-option [value]="'fournisseur'">
                        {{"fournisseur"|translate}}
                    </mat-option>
                </mat-select>

            </mat-form-field>

            <!--       <form (ngSubmit)="submit()" [formGroup]="form"  >-->
            <div *ngIf="key=='acheteur'">
                <form (ngSubmit)="loadacheteur()" [formGroup]="form" fxLayout="column">
                    <div fxFlex="100" fxFlex.lt-md="100">

                        <div fxFlex="100" fxFlex.lt-md="100">

                            <!--   <app-text-field
                                [control]="getFormControl('nom')"
                                [label]="'Nom acheteur public'"
                              ></app-text-field> -->

                            <!--    <app-combo-acheteur [control]="getFormControl('nom')" [label]="'Nom acheteur public'">
                               </app-combo-acheteur> -->

                            <app-combo-acheteur-etat (object)="send($event)" (annulation)="annuler()"
                                                     [control]="getFormControl('nom')"
                                                     [label]="'Nom acheteur public'|translate">
                            </app-combo-acheteur-etat>
                        </div>

                        <div fxFlex="100" fxFlex.lt-md="100" class="mx-3">

                            <!--  <mat-form-field class="example-full-width" appearance="outline">
                               <mat-label>N° de réception</mat-label>
                               <input matInput  [attr.disabled]="true"

                               formControlName='instRcvNo'>
                             </mat-form-field> -->


                            <app-text-field [discond]='true' [control]="getFormControl('instRcvNo')"
                                            [label]="'N° de réception'"></app-text-field>
                        </div>

                        <div fxFlex="100" fxFlex.lt-md="100">

                            <app-text-field [control]="getFormControl('instRegNo')" [label]="'Code acheteur public'">
                            </app-text-field>
                        </div>
                    </div>
                    <div fxFlex="100" fxFlex.lt-md="100" fxLayoutAlign="end center">
                        <button class="btn-blue" mat-raised-button type="submit">
                            <mat-icon>{{ icons.search }}</mat-icon>
                            <span translate>search</span>
                        </button>
                        <button class="mx-2" (click)="reset()" color="primary" mat-raised-button type="button">
                            <mat-icon>{{ icons.reset }}</mat-icon>
                            <span translate>reset</span>
                        </button>
                    </div>

                </form>
            </div>

            <div *ngIf="key=='fournisseur'">

                <form (ngSubmit)="getFirstCardF()" [formGroup]="formF" fxLayout="column">
                    <!--                <div  fxLayout="row wrap" fxLayoutAlign="flex-start center">-->
                    <!--  <div fxFlex="100" fxFlex.lt-md="100">
                       <app-select-common
                         [withfiltre]="true"
                         [control]="get('categorie')"
                         [label]="'categorie'"
                         [code]="CommmCode.categorie"
                       ></app-select-common>
                     </div> -->
                    <!-- <div
                      *ngIf="isPersonnePhysique(get('categorie').value)"
                      fxFlex="50"
                      fxFlex.lt-md="50"
                    >
                      <app-type-identifiant [control]="get('cin')">
                      </app-type-identifiant>
                    </div> -->

                    <!--  <div fxFlex="50" fxFlex.lt-md="100">
                       <app-text-field
                         [control]="get('identifiantunique')"
                         [label]="setlable()"
                       ></app-text-field>
                     </div> -->
                    <!--   <div
                        fxFlex="50"
                        fxFlex.lt-md="100"
                        *ngIf="isgroupeArisant(get('categorie').value)"
                      >
                        <app-text-field
                          [control]="get('num_unique_artisan')"
                          [label]="'N° du registre de commerce ou numéro unique de l artisan'	"
                        ></app-text-field>
                      </div> -->

                    <div fxFlex="100" fxFlex.lt-md="100">
                        <app-text-field [control]="get('num_unique_artisan')" [label]="'Identifiant unique'">
                        </app-text-field>
                    </div>
                    <!--  <div fxFlex="50" fxFlex.lt-md="100">
                       <app-select-date [control]="get('date_redac')" [label]="setdate()">
                       </app-select-date>
                     </div> -->

                    <div fxFlex="100" fxFlex.lt-md="100" fxLayout="row" fxLayoutAlign="end center">
                        <button class="btn-blue" mat-raised-button type="submit">
                            <mat-icon>{{ icons.search }}</mat-icon>
                            <span translate>search</span>
                        </button>
                        <button class="mx-2" (click)="reset()" color="primary" mat-raised-button type="button">
                            <mat-icon>{{ icons.reset }}</mat-icon>
                            <span translate>reset</span>
                        </button>
                    </div>

                    <!--                </div>-->


                </form>

            </div>
        </mat-card-content>
    </app-card>


    <div *ngIf="cardacheteur&&key=='acheteur'&&dataacheteur">
        <div style="margin-top: 4%">
            <app-fiche-consultation [data]="[dataacheteur]" [label]="'general_information'"
                                    [labels]="generalInfosCard.labels" [dataColumns]="generalInfosCard.dataColumns.fr"
                                    [dataColumnsAr]="generalInfosCard.dataColumns.ar"
                                    [dataColumnsEn]="generalInfosCard.dataColumns.en"
                                    [langue]="translate.getDefaultLang()">
            </app-fiche-consultation>
        </div>

        <div fxLayoutAlign="end center">

            <div style="padding-top:1.5% ;padding-left: 1.5%;" fxLayoutAlign="end center">
                <span *ngIf="dataacheteur?.excStat == 1">
<!--                    dataacheteur?.instRegNo-->
                    <app-export-reports-btns #exportReportsBtnsComponent
                                             [inputData]="{etat: 'generateEtatApprob', fields: {instRcvNo: dataacheteur?.instRegNo}}"></app-export-reports-btns>
                </span>

                <!-- <button *ngIf="dataacheteur.cdNmFr!='Refusé'" (click)="detailEtatAcheteur()" color="primary"
                    mat-raised-button> -->
                <button *ngIf="dataacheteur.excStat != 3 && dataacheteur.excStat != 4" (click)="detailEtatAcheteur()"
                        color="primary" mat-raised-button>
                    <span translate>Afficher les détails</span>
                </button>
            </div>

        </div>
    </div>


    <div *ngIf="cardF&&key=='fournisseur'">
        <mat-card appCard style="box-shadow: 0px 6px 22px -8px rgba(0, 0, 0, 0.2)">
            <mat-card-header class="titree">
                {{ "general_information" | translate }}
            </mat-card-header>
            <mat-card-content class="card-content">

                <table class="table table-bordered">
                    <colgroup>
                        <col style="width:20%">
                        <col style="width:30%">
                        <col style="width:20%">
                        <col style="width:30%">
                    </colgroup>
                    <tbody>
                    <tr>
                        <th class="table-active" translate>N° du registre de commerce ou numéro unique de l artisan</th>
                        <td colspan="3">{{data_F.bizRegNo}}</td>
                    </tr>
                    <tr>
                        <th class="table-active" translate>Nom de la société</th>
                        <td colspan="3">{{data_F.supplierNm}}</td>
                    </tr>
                    <tr>
                        <th rowspan="2" class="table-active" translate>Adresse</th>
                        <td colspan="3">

                            {{data_F.addr1}}
                        </td>
                    </tr>
                    <tr>
                        <td colspan="3">


                            {{data_F.addr2}} </td>
                    </tr>
                    <tr>
                        <th class="table-active" translate>Date de la demande</th>
                        <td>{{data_F.reqDt | dfj}}</td>
                        <th class="table-active" translate>Date du traitement</th>
                        <td>{{data_F.excDt | dfj}}</td>
                    </tr>
                    <tr>
                        <th class="table-active" translate>Etat du déroulement</th>
                        <td colspan="3" *ngIf="current_lang=='en'">
                            {{data_F.excStatEn}}
                        </td>
                        <td colspan="3" *ngIf="current_lang=='ar'">
                            {{data_F.excStatAr}}
                        </td>
                        <td colspan="3" *ngIf="current_lang=='fr'">
                            {{data_F.excStatFr}}
                        </td>
                    </tr>
                    <tr>
                        <th class="table-active" translate>Motif</th>
                        <td colspan="3">


                            {{data_F.excReason }}
                        </td>
                    </tr>
                    </tbody>
                </table>

            </mat-card-content>


        </mat-card>

        <div fxLayoutAlign="end center" class="mt-2">
                 <span *ngIf="data_F.excStat!=3 && data_F.excStat!=1 && data_F.excStat!=4">
                            <app-export-reports-btns #exportReportsBtnsComponent
                                                     [inputData]="{etat: 'generateRegApprob', fields: {bizRegNo: data_F?.bizRegNo, corporationCl: data_F?.corporationCl}}"></app-export-reports-btns>

                            <button class="mx-1" (click)="detailF()"
                                    color="primary" mat-raised-button>
                                <span translate>Afficher les détails</span>
                            </button>

                 </span>


        </div>
    </div>
</app-spinner-container>
